<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M3.08502 5.33594H12.085M0.835022 0.835938H14.335M5.33502 9.83594H9.83502"
    stroke="var(--stroke-color)"
    stroke-width="1.67"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
